import React, { useEffect } from "react";
import styles from "./style.module.css";
import Banner from "../../components/Banner";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer";
import { individualScreenData, myList } from "./data";
import DigitalCard from "../../components/DigitalCard";
import Header from "../../components/Header";
import Section from "../../components/Section/TanentSection";
// import Section from "../../components/tenantScreen/TanentSection";

const IndividualScreen = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top of the page when the component mounts
  }, []);

  return (
    <div className={styles.mainContainer}>
      <Navbar />
      <Header
        width="1020px"
        heading="A product designed to empower you with financial independence and self-sufficiency"
        desc="Regardless of whether you're a student, self-employed, or an entrepreneur, this product provides you with a seamless avenue to effortlessly earn for your needs"
      />
      <Section
        color="#002540"
        myList={myList}
        text="Earn big without spending a dime."
      />
      <div className={styles.innerContainer}>
        <div className={styles.header}>
          <h3>
            Enable an <span> earning possibility</span>
          </h3>
          <p>We've acquired it and tailored it precisely to generate income</p>
        </div>
        <div className={styles.infoContainer}>
          {individualScreenData.map((data) => (
            <DigitalCard name={data.name} desc={data.desc} img={data.img} />
          ))}
        </div>
      </div>
      <Banner
        text="Embark your earning path with Avasify"
        backgroundColor="#09904F"
      />
      <Footer />
    </div>
  );
};

export default IndividualScreen;
